import React from 'react';
import { SyncOutlined } from '@ant-design/icons';
import {
  Card,
  Badge,
  Progress,
  Tag,
  Row,
  Col,
  Select,
  Button,
  Switch,
  Drawer,
  Menu,
  Dropdown,
  Input,
  Tabs,
  Popover,
  Divider,
  Spin,
  Checkbox,
  DatePicker,
  Tooltip,
} from 'antd';
import moment from 'moment';
import { FormattedMessage, formatMessage } from 'umi-plugin-react/locale';
import AllServices from '../../../../config/AllServices';

const { Meta } = Card;
const { TabPane } = Tabs;
const { Search } = Input;
const { Option } = Select;

function RenderSelectedFilters(props) {
  let {
    filteredResources,
    appliedFilters,
    allCloudAccountsList,
    onChange,
    clearSelected,
    counts,
    handleHistoryChange,
  } = props;

  appliedFilters = appliedFilters.sort((a, b) => {
    let pass = a.type.toLowerCase();
    let fail = b.type.toLowerCase();

    if (pass < fail) {
      return -1;
    } else if (pass > fail) {
      return 1;
    }
    return 0;
  });

  return (
    <div className=".ant-drawer-wrapper-body">
      <Card
        className=".ant-drawer-wrapper-body"
        bordered={false}
        bodyStyle={{ paddingBottom: '0px' }}
      >
        <div className="sig-card" style={{ marginTop: -4 }}>
          <Row type="flex">
            <Col
              span={24}
              style={{
                overflowX: 'auto',
                height: 50,
                whiteSpace: 'nowrap',
              }}
            >
              {appliedFilters &&
                appliedFilters.map((filterKey, i) => {
                  return filterKey.value.map(v => {
                    let value = v;

                    if (filterKey.type === 'history') {
                      value = moment(value).format('MMM Do, YYYY');
                      let currentData = moment(new Date()).format('MMM Do, YYYY');

                      if (value === currentData) {
                        value = '';
                      }
                    }

                    if (filterKey.type === 'cloudAccounts') {
                      let currentAcc = allCloudAccountsList.filter(account => account.id === value);

                      return (
                        <Tooltip key={v} title={currentAcc.length && currentAcc[0].accountName}>
                          <Tag
                            key={currentAcc.length ? currentAcc[0].accountName : ''}
                            style={{ fontSize: 14, marginTop: 8 }}
                          >
                            {currentAcc.length && currentAcc[0].accountName}
                            {currentAcc.length && currentAcc[0].provider === 'AWS' ? (
                              <img
                                src="/awslogo.png"
                                alt="aws"
                                style={{ height: 18, marginBottom: '3px' }}
                              />
                            ) : currentAcc.length && currentAcc[0].provider === 'AZURE' ? (
                              <img
                                src="/azure@2x.png"
                                alt="azure"
                                style={{ height: 12, marginLeft: 7 }}
                              />
                            ) : (
                              <img
                                src="/gcplogo.png"
                                alt="gcp"
                                style={{ height: 20, marginRight: -10, marginLeft: -4 }}
                              />
                            )}
                          </Tag>
                        </Tooltip>
                      );
                    } else if (filterKey.type === 'region') {
                      return (
                        <Tooltip
                          key={v}
                          title={value === '' || Array.isArray(value) ? 'Global' : value}
                        >
                          <Tag key={value} style={{ fontSize: 14, marginTop: 8 }}>
                            {value === '' || Array.isArray(value) ? 'Global' : value}
                          </Tag>
                        </Tooltip>
                      );
                    } else {
                      if (filterKey.type === 'service') {
                        return (
                          <Tooltip key={v} title={AllServices.getFullName(value)}>
                            <Tag key={value} style={{ fontSize: 14, marginTop: 8 }}>
                              {AllServices.getShortName(value)}
                            </Tag>
                          </Tooltip>
                        );
                      } else {
                        if (!value) return null;

                        return (
                          <Tooltip key={v} title={value}>
                            <Tag style={{ fontSize: 14, marginTop: 8 }}>{value}</Tag>
                          </Tooltip>
                        );
                      }
                    }
                  });
                })}
              {appliedFilters.length > 2 && (
                <div style={{ marginTop: 8, display: 'inline' }} onClick={clearSelected}>
                  <SyncOutlined
                    style={{ color: '#0090ff', marginTop: 3, marginLeft: 6, cursor: 'pointer' }}
                  />{' '}
                  <span style={{ color: '#0090ff', marginLeft: 6, cursor: 'pointer' }}>
                    Clear All
                  </span>
                </div>
              )}
            </Col>
          </Row>
        </div>
        <Row style={{ float: 'right', marginBottom: '7px', marginTop: '20px' }}>
          <span style={{ marginRight: 10 }}>
            <Badge
              showZero
              count={
                appliedFilters.length > 0
                  ? counts.totalRisks -
                      (counts.totalSuppressedRisks ? counts.totalSuppressedRisks : 0) >
                    0
                    ? counts.totalRisks -
                      (counts.totalSuppressedRisks ? counts.totalSuppressedRisks : 0)
                    : 0
                  : 0
              }
              overflowCount={9999}
              style={{
                background: '#228FFD',
                color: 'white',
                fontWeight: 600,
                marginTop: -3,
                marginRight: 7,
              }}
            />
            Total Risks found
          </span>

          <span style={{ marginRight: 10 }}>
            <Badge
              showZero
              count={appliedFilters.length > 0 ? counts.totalSuppressedRisks : 0}
              overflowCount={1000}
              style={{
                background: '#228FFD',
                color: 'white',
                fontWeight: 600,
                marginTop: -3,
                marginRight: 7,
              }}
            />
            Suppressed Risks
          </span>

          <span style={{ marginLeft: 10 }}>
            <Switch checkedChildren="Hide" unCheckedChildren="Show" onChange={onChange} />
          </span>
        </Row>
        <Row style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
          <Badge
            showZero
            count={
              appliedFilters.length > 0 && filteredResources && filteredResources.length > 0
                ? filteredResources.length
                : 0
            }
            overflowCount={9999}
            style={{
              background: '#228FFD',
              color: 'white',
              fontWeight: 600,
              marginTop: -3,
              marginRight: 7,
            }}
          />
          Resources found
        </Row>
      </Card>
    </div>
  );
}

export default RenderSelectedFilters;
